import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import * as serviceWorker from './serviceWorkerRegistration';

import ContextWrapper from './context/ContextWrapper';
 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    
        <ContextWrapper>
            <App />
        </ContextWrapper>
);

serviceWorker.register();

//<React.StrictMode></React.StrictMode>